document.addEventListener("DOMContentLoaded", () => {
    document
        .querySelectorAll(".atha-category-slider")
        .forEach(initCategorySlider);
});

function initCategorySlider(slider) {

    const track = slider.querySelector(".atha-category-track");
    const cards = [...track.querySelectorAll(".atha-category-card")];

    const prev = slider.querySelector(".atha-category-prev");
    const next = slider.querySelector(".atha-category-next");

    if (!track || cards.length < 2) return;

    /* --------------------------------
       CARD WIDTH
    -------------------------------- */

    const getCardStep = () => {
        if (!cards[0]) return 0;

        const style = getComputedStyle(track);
        const gap = parseFloat(style.gap) || 0;

        return cards[0].getBoundingClientRect().width + gap;
    };


    /* --------------------------------
       NATIVE SMOOTH SCROLL
    -------------------------------- */

    function scrollNext() {

        track.scrollBy({
            left: getCardStep(),
            behavior: "smooth"
        });

    }


    function scrollPrev() {

        track.scrollBy({
            left: -getCardStep(),
            behavior: "smooth"
        });

    }


    /* --------------------------------
       ARROWS
    -------------------------------- */

    if (next) {

        next.addEventListener("click", () => {
            scrollNext();
        });

    }


    if (prev) {

        prev.addEventListener("click", () => {
            scrollPrev();
        });

    }


    /* --------------------------------
       TOUCH
       
       IMPORTANT:
       We do NOT manually move the slider.
       The browser handles native touch
       scrolling and momentum.
    -------------------------------- */

    track.style.scrollBehavior = "smooth";

    track.style.webkitOverflowScrolling = "touch";


    /* --------------------------------
       PREVENT IMAGE DRAG
    -------------------------------- */

    cards.forEach(card => {

        const img = card.querySelector("img");

        if (img) {
            img.draggable = false;
        }

    });


    /* --------------------------------
       DESKTOP MOUSE DRAG
    -------------------------------- */

    let isDragging = false;
    let startX = 0;
    let startScroll = 0;


    track.addEventListener("mousedown", (e) => {

        if (window.innerWidth < 750) return;

        isDragging = true;

        startX = e.pageX;
        startScroll = track.scrollLeft;

        track.style.cursor = "grabbing";
        track.style.scrollBehavior = "auto";

    });


    window.addEventListener("mousemove", (e) => {

        if (!isDragging) return;

        const distance = e.pageX - startX;

        track.scrollLeft = startScroll - distance;

    });


    window.addEventListener("mouseup", () => {

        if (!isDragging) return;

        isDragging = false;

        track.style.cursor = "";
        track.style.scrollBehavior = "smooth";

    });


    /* --------------------------------
       RESIZE
    -------------------------------- */

    let resizeTimer;

    window.addEventListener("resize", () => {

        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {

            track.style.scrollBehavior = "auto";

            track.scrollLeft = 0;

            requestAnimationFrame(() => {
                track.style.scrollBehavior = "smooth";
            });

        }, 150);

    });

}